module.exports = __webpack_public_path__ + "img/Artboard-31.4404c457.webp";